/** @file PLATFORM: the Mod-key platform of this browser (win, mac or linux), detected once. */
import { detectPlatform } from '@zilo/pose3d-shortcuts/detectPlatform';
import type { Platform } from '@zilo/pose3d-shortcuts/types';

/** `detectPlatform(navigator)`; `linux` outside a browser. */
export const PLATFORM: Platform = detectPlatform(typeof navigator === 'undefined' ? undefined : navigator);
